// @flow
import React from 'react';
import { injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';
import Link from 'box-ui-elements/es/components/link/Link';
import {
  BOX_TERMS_OF_SERVICE_URL,
  BOX_PRIVACY_NOTICE_URL,
} from '../../../constants';
import messages from './messages';
import css from './footer.module.scss';

type Props = InjectIntlProvidedProps;

const Footer = (props: Props) => {
  const { intl } = props;

  return (
    <div className={css.footer}>
      <div className={css.messageRow}>
        {intl.formatMessage(messages.footerMessage)}
      </div>
      <div className={css.buttonRow}>
        <Link
          className={css.linkButton}
          href={BOX_TERMS_OF_SERVICE_URL}
          target="_blank"
        >
          {intl.formatMessage(messages.termOfServiceLink)}
        </Link>
        <span className={css.seperator}>|</span>
        <Link
          className={css.linkButton}
          href={BOX_PRIVACY_NOTICE_URL}
          target="_blank"
        >
          {intl.formatMessage(messages.privacyNoticeLink)}
        </Link>
      </div>
    </div>
  );
};

export { Footer };
export default injectIntl(Footer);
